import _get from "lodash/get";
import "core-js/modules/es6.regexp.split.js";
import nrAwareErrorHandler from './nr-aware-error-handler';
var errorHandler = nrAwareErrorHandler('[Compare-CC-Bar.cookie-helpers]');
export function setCookie(name, value, days, path) {
  if (!name) {
    errorHandler(new Error('setCookie called without a cookie name.'));
  }

  if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
    var d = new Date();
    d.setTime(d.getTime() + (days || 30) * 24 * 60 * 60 * 1000);
    var expires = "expires=".concat(d.toUTCString()); // eslint-disable-next-line no-param-reassign -- directive added automatically by Shepherd migration

    path = "path=".concat(path || '/');
    document.cookie = "".concat(name, "=").concat(encodeURIComponent(value), "; ").concat(expires, "; ").concat(path);
  } else {
    errorHandler(new Error('setCookie called without a window.'));
  }
}
/**
 * Get data out of a cookie. Value will be URI-decoded when on the client side.
 *
 * @param {string} name - name of the cookie.
 * @param {Request} [serverRequest] - server-request, required only when executing on the server.
 * @returns {string} - value from the cookie.
 */

export function getCookie(name, serverRequest) {
  if (!name) {
    errorHandler(new Error('getCookie called without a cookie name.'));
  }

  if (serverRequest) {
    return _get(serverRequest, ['cookies', name]);
  }

  if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
    var matchedCookie;
    var cookies = document.cookie.split('; ');
    cookies.forEach(function (cookie) {
      var cookieData = cookie.split('=');

      if (cookieData[0] === name) {
        matchedCookie = cookieData[1]; // eslint-disable-line prefer-destructuring
      }
    });
    return matchedCookie ? decodeURIComponent(matchedCookie) : matchedCookie;
  } // Log an error without throwing it.


  errorHandler(new Error('getCookie called on the server without a requestObject. Returning undefined.'));
  return undefined;
}
/**
 * A `JSON.parse()` around `getCookie()`.
 *
 * @param {string} nameOfCookie -
 * @param {*} defaultValue - if specified, this will override a falsy cookie value.
 * @param {Request} [serverRequest] - only required when called on the server side.
 */

export var getJSONFromCookie = function getJSONFromCookie(nameOfCookie, defaultValue, serverRequest) {
  var value = getCookie(nameOfCookie, serverRequest);

  try {
    return value ? JSON.parse(value) : defaultValue || value;
  } catch (err) {
    errorHandler(new Error("Error JSON.parsing value `".concat(value, "`")));
    return '';
  }
};